import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';

export function ProtectedRoute({ requireRole }: { requireRole?: string }) {
  const { user, hydrated, hydrate } = useAuthStore();

  useEffect(() => {
    if (!hydrated) hydrate();
  }, [hydrated, hydrate]);

  if (!hydrated) {
    return <div className="p-6 text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireRole && user.role !== requireRole && user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
